// extracted by mini-css-extract-plugin
module.exports = {"emptyCont":"emptyCont__0o-d","img":"img__gWBN","txt":"txt__0910"};
    if(module.hot) {
      // 1724307570490
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  